export function LegalP({ children }: { children: React.ReactNode }) {
  return (
    <p
      className="mb-4 text-[15px] leading-[1.8] last:mb-0"
      style={{ color: "var(--muted-foreground)" }}
    >
      {children}
    </p>
  );
}

export function LegalUL({ children }: { children: React.ReactNode }) {
  return <ul className="mb-4 space-y-2 last:mb-0">{children}</ul>;
}

export function LegalLI({ children }: { children: React.ReactNode }) {
  return (
    <li
      className="flex gap-3 text-[15px] leading-[1.8]"
      style={{ color: "var(--muted-foreground)" }}
    >
      <span
        className="mt-[11px] h-1 w-1 shrink-0 rounded-full"
        style={{ background: "var(--muted-foreground)", opacity: 0.5 }}
      />
      <span>{children}</span>
    </li>
  );
}

export function LegalOL({ children }: { children: React.ReactNode }) {
  return (
    <ol
      className="mb-4 list-inside list-decimal space-y-2 text-[15px] leading-[1.8] last:mb-0"
      style={{ color: "var(--muted-foreground)" }}
    >
      {children}
    </ol>
  );
}

export function LegalStrong({ children }: { children: React.ReactNode }) {
  return (
    <strong className="font-semibold" style={{ color: "var(--foreground)" }}>
      {children}
    </strong>
  );
}

export function LegalH3({ children }: { children: React.ReactNode }) {
  return (
    <h3
      className="mt-6 mb-2 text-lg font-semibold first:mt-0"
      style={{ color: "var(--foreground)" }}
    >
      {children}
    </h3>
  );
}

export function ChevronRight() {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="h-3 w-3 shrink-0"
      style={{ color: "var(--muted-foreground)", opacity: 0.5 }}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 4l4 4-4 4" />
    </svg>
  );
}
